import React from 'react'

const H1 = (props) => {
  return (
    <div className='font-bold text-3xl '>{props.data}</div>
  )
}

export default H1